import { compose, mapProps } from 'recompose';
import { replace, pipe, curry, invoker, defaultTo } from 'ramda';
import AdPrice from './AdPrice';

const calculateUnitPrice = (price, amount) => (price / amount);
const toFixed = invoker(1, 'toFixed');
const replaceDotWithComma = replace(/\./g, ',');

const displayPrice = pipe(
  defaultTo(0),
  curry(calculateUnitPrice),
  toFixed(2),
  replaceDotWithComma,
);

const enhanceProps = mapProps(({ price, amount }) => ({ text: `(R$ ${displayPrice(price, amount)} / anúncio)` }));

export default compose(enhanceProps)(AdPrice);
